
import Vue from "vue";

import Loading from "@/components/basic/Loading.vue";
import ErrorMessage from "@/components/basic/ErrorMessage.vue";

import Grid from "@/components/layout/Grid.vue";
import Row from "@/components/layout/Row.vue";
import Column from "@/components/layout/Column.vue";
import Checkbox from "@/components/form/Checkbox.vue";
import SummaryButton from "@/components/basic/SummaryButton.vue";
import TicketSelectionDialog from "./TicketSelectionDialog.vue";

import { ReportSettingsModel } from "../../models/ReportSettingsModel";
import { ChecklistEntry } from "@/inspection/shared/models/ChecklistEntry";
import StyledText from "@/components/basic/StyledText.vue";

export default Vue.extend({
  components: {
    Loading,
    ErrorMessage,
    Grid,
    Row,
    Column,
    Checkbox,
    SummaryButton,
    TicketSelectionDialog
  },
  props: {
    assignmentId: {
      type: String,
      default: "0"
    },
    reportType: {
      type: String,
      default: ""
    },
    reportId: {
      type: String,
      default: "0"
    }
  },
  data(): { model: ReportSettingsModel; ticketDialogVisible: boolean } {
    return {
      model: new ReportSettingsModel(),
      ticketDialogVisible: false
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    hiddenTicketIds(): number[] {
      const field = this.model.getFormField("hidden_ticket_ids");
      const value = field?.value as number[] | undefined;
      return Array.isArray(value) ? value : [];
    },
    hiddenTicketCount(): number {
      return this.hiddenTicketIds.length;
    },
    hiddenTicketSummary(): string {
      if (this.hiddenTicketCount === 0) {
        return "Alle Tickets werden gedruckt";
      }

      if (this.hiddenTicketCount === 1) {
        return "1 Ticket ausgeblendet";
      }

      return `${this.hiddenTicketCount} Tickets ausgeblendet`;
    },
    checklistEntries(): ChecklistEntry[] {
      return this.model.report.assignment?.checklist?.entries ?? [];
    }
  },
  methods: {
    load() {
      this.model.load(this.assignmentId, this.reportType, this.reportId);
    },
    setHiddenTicketIds(ids: number[]) {
      this.model.setFormField("hidden_ticket_ids", ids);
    }
  },
  watch: {
    ticketDialogVisible(isOpen: boolean) {
      if (isOpen && !this.model.report.success && !this.model.report.loading) {
        this.model.loadReport();
      }
    }
  }
});
